<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M860.9 191.2h-52.3v-45c0-8.7-7.1-15.8-15.8-15.8H735c-8.7 0-15.9 7.1-15.9 15.8v45H306.9v-45c0-8.7-7.1-15.8-15.8-15.8h-57.8c-8.8 0-15.8 7.1-15.8 15.8v45H165c-50.7 0-92 41.2-92 92v518.4c0 50.9 41.2 92.1 92 92.1h695.9c50.8 0 92.1-41.2 92.1-92.1V283.1c0-50.7-41.3-91.9-92.1-91.9zm33.8 610.3c0 18.7-15.2 33.9-33.9 33.9H165c-18.5 0-33.7-15.1-33.7-33.9V453.9h763.5v347.6z" data-follow-fill="currentColor" :fill="_fill" />
      <circle r="40.6" cy="577.2" cx="291.1" data-follow-fill="currentColor" :fill="_fill" />
      <circle r="40.6" cy="577.2" cx="513" data-follow-fill="currentColor" :fill="_fill" />
      <circle r="40.6" cy="577.2" cx="734.9" data-follow-fill="currentColor" :fill="_fill" />
      <circle r="40.6" cy="736.1" cx="291.1" data-follow-fill="currentColor" :fill="_fill" />
      <circle r="40.6" cy="736.1" cx="513" data-follow-fill="currentColor" :fill="_fill" />
      <circle r="40.6" cy="736.1" cx="734.9" data-follow-fill="currentColor" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
